<script>

    import { toast } from 'bulma-toast'
    import { LocationsStore, LocationStore } from '../stores'
    
    import LocationsService from '../$services/locations.service'
    import DateMethods from '../$methods/date.methods'

    import Pagination from '../$components/pagination.header.svelte'
    import Search from '../$components/search.svelte'
    import Button from '../$components/button.svelte'
    import Table from '../$components/table.svelte'
    import Icon from '../$components/icon.svelte'

    let loading = false
    let metadata = {}
    let query = {}

    getLocations()

    async function getLocations() {

        loading = true
        const resp = await LocationsService.getLocations(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        metadata = resp.data.metadata
        query = resp.data.query

        LocationsStore.set(resp.data.locations)
    }

</script>

<Search bind:value={query.find} on:enter={getLocations} />

<div class="items space">
    <Button on:click={() => LocationStore.modalCreate()} text="Agregar" icon="plus" color="primary" size="small" />
    <Pagination bind:metadata bind:query on:change={getLocations} />
</div>

<Table items={ $LocationsStore.length } total={ metadata.limit } { loading }>
    <thead>
        <tr>
            <th>#</th>
            <th>Alias</th>
            <th>Contacto</th>
            <th>Código postal</th>
            <th>Estado</th>
            <th>Fecha</th>
            <td></td>
        </tr>
    </thead>
    <tbody>
        {#each $LocationsStore as location, index}
            <tr>
                <td>{ (index+1) + (query.page * metadata.limit) }</td>
                <td>{ location.alias }</td>
                <td>{ location.contact }</td>
                <td>{ location.zipcode }</td>
                <td>{ location.state }</td>
                <td>{ DateMethods.dateTimeLarge(location.created) }</td>
                <td>
                    <Icon on:click={() => LocationStore.modalRead(location)} icon="eye" pointer />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>